// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__187Hh","textarea":"styles_textarea__1d_6y"};